import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-inner">
                <span>&copy; {new Date().getFullYear()} Kazoku Quartet</span>
                <span className="footer-sep">|</span>
                <span>Site by <a href="https://github.com/dgelok" target="_blank" rel="noopener noreferrer">GelokDev</a></span>
            </div>
        </footer>
    );
}

export default Footer;
